import React, { useState } from "react";
// import { Slider, RangeSlider } from "rsuite";
import { BsPlayFill, BsFillVolumeDownFill, BsPauseFill } from "react-icons/bs";
// import { H5, Slider, Switch } from "@blueprintjs/core";
import { Slider, Popover } from "@material-ui/core";

const containerStyles = {
  width: "100%",
  height: "40px",
  zIndex: "4",
  background: "white",
  display: "flex",
  justifyContent: "center",
  marginTop: "-30px",
  // position: "absolute",}
};

const volumeStyles = {
  width: "100px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: "4",
};

const actionStyles = {
  width: "100px",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: "4",
};

const sliderStyles = {
  width: "80%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const Player = ({ sound }) => {
  const [status, setStatus] = useState("OFF");
  const [interval, setTimeInterval] = useState(null);
  const [progress, setProgress] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [volume, setVolumeCurrent] = useState(1);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setDuration = () => {
    var seconds = Math.floor(this.sound.duration());
    var minutes = Math.floor(seconds / 60);
    var leftoverSec = seconds - minutes * 60;

    this.setState({ duration: `${minutes}:${leftoverSec}` }, () => {
      console.log("duration", this.state.duration);
    });
  };

  const setCurrentTime = () => {
    const int = setInterval(() => {
      var duration = sound.duration();
      var current = sound.seek();
      var percentComplete = Math.floor((current / duration) * 100);
      var seconds = Math.floor(current / 1);
      var minutes = Math.floor(seconds / 60);
      var leftoverSec = seconds - minutes * 60;
      var currentTime = `${minutes}:${
        leftoverSec < 10 ? "0" + leftoverSec : leftoverSec
      }`;
      //   console.log(seconds);
      //   debugger;
      if (current >= duration) {
        setStatus("OFF");
        setProgress(0);
        clearInterval(int);
        sound.stop();
      } else if (seconds) {
        setProgress(current);
      }

      //   this.setState({
      //     progress: seconds ? currentTime : "0:00",
      //     complete: percentComplete,
      //   });
    }, 100);
  };

  const setVolume = (e, val) => {
    setVolumeCurrent(val);
    sound.volume(val);
  };

  const playMusic = () => {
    setStatus("ON");
    sound.play();
    setCurrentTime();
  };

  const stopMusic = () => {
    setStatus("OFF");
    sound.pause();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <Popover
        onClose={handleClose}
        onEntering={() => {
          //   debugger;
          setVolumeCurrent(sound.volume());
        }}
        id={id}
        open={open}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        anchorEl={anchorEl}
      >
        <div
          style={{
            width: "50px",
            height: "150px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "4",
          }}
        >
          <div style={{ height: "70%", zIndex: "4" }}>
            <Slider
              style={{ color: "#ffd400" }}
              defaultValue={volume}
              min={0}
              max={1}
              step={0.1}
              orientation="vertical"
              onChange={setVolume}
              //   track="inverted"
              aria-labelledby="vertical-slider"
            />
          </div>
        </div>
      </Popover>
      <div style={containerStyles}>
        <div style={{ width: "80%", display: "flex", flexDirection: "row" }}>
          <div style={actionStyles}>
            {status === "OFF" ? (
              <BsPlayFill
                style={{ width: "50px", height: "25px", color: "#ffd400" }}
                onClick={playMusic}
              />
            ) : (
              <BsPauseFill
                style={{ width: "50px", height: "25px", color: "#ffd400" }}
                onClick={stopMusic}
              />
            )}
          </div>
          <div style={sliderStyles}>
            <Slider
              min={0}
              max={376.1}
              step={0.1}
              // labelStepSize={10}
              // onChange={this.getChangeHandler("value2")}
              value={progress}
              vertical={false}
              style={{ color: "#ffd400" }}
            />
          </div>
          <div style={volumeStyles}>
            <BsFillVolumeDownFill
              aria-describedby={id}
              style={{ width: "50px", height: "25px", color: "#ffd400" }}
              onClick={handleClick}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Player;
